import IEmpresas from "../interfaces/IEmpresas";
import IReports from "../interfaces/IReports";
import { IPeriodo, IUsuario } from "../interfaces/IUsuario";
import { getSituacaoAcademica } from "../utilities/constantes";

const defaultProps: IReports = {
  // Configurações gerais do relatório
  config: {
    // Orientação da página: "portrait" (retrato) ou "landscape" (paisagem)
    orientation: "portrait",

    // Modo de exibição das informações de página
    // "footer-simple": Exibe no rodapé "Página X de Y, Emitido por Operador - Em: Data - Hora"
    // "header-detailed": Exibe no cabeçalho "Pág.: X / Y, data: DD/MM/AAAA, hora: HH:MM, emitido por Operador"
    pageInfoMode: 'header-detailed',

    // Altura do cabeçalho em milímetros
    headerHeight: 35,

    // Altura do rodapé em milímetros
    footerHeight: 5,

    // Tamanho da fonte base em pontos
    fontSize: 9,

    // Tamanho da fonte do título em pontos
    titleFontSize: 14,

    // Tamanho da fonte dos detalhes em pontos
    detailFontSize: 10,

    // Família da fonte: "arial", "times", "courier", "calibri", "tahoma"
    fontFamily: "arial",

    // Alternar cores das linhas nas tabelas
    alternateRowColors: true,
    // Nota: O sistema usa fatores de utilização de espaço diferentes por orientação:
    // - 130% para orientação vertical (portrait)
    // - 110% para orientação horizontal (landscape)
    // Isso permite otimizar o uso do espaço disponível em cada página

    // Espaçamento interno das células em pontos
    cellPadding: 4,

    // Configuração do logo
    logo: {
      // URL do logo
      url: "https://exemplo.com/logo.png",

      // Tamanho do logo em milímetros
      size: 40,

      // Formato do logo: "square" (quadrado) ou "horizontal"
      format: "square",

      // Margem entre o logo e o texto do cabeçalho em milímetros
      textMargin: 5,
    },

    marginRight: 10,
    marginLeft: 10,
    marginTop: 5,
    marginBottom: 5
  },

  // Linhas do cabeçalho
  headerLines: [],

  // Linhas do rodapé
  footerLines: [
    { text: "Documento Confidencial", align: "left" },
    { text: "Uso Interno", align: "left" },
  ],

  // Nome do operador que emitiu o relatório
  operatorName: "",

  // Conteúdo do relatório - Array com todos os elementos que compõem o relatório
  content: [],
}

const getColumnNome = (aluno: any, data: any) => {
  switch (data?.ImprimirNome) {
    case 1:
      return aluno.Nome
      break;
    case 2:
      return aluno.NomeResponsavel
      break;
    case 3:
      return aluno.Pai
      break;
    case 4:
      return aluno.Mae
      break;    
    default:
      return 'uknown'
      break;
  }
}

const buildAlunosAssinatura = (data: any, formData: any, empresaSelecionada?: IEmpresas, periodoSelecionado?: IPeriodo, usuario?: IUsuario): IReports => {

  const report: IReports = {
  ...defaultProps,
  config: {
    ...defaultProps.config,          
    logo: {
      url: empresaSelecionada?.Logo,
    },
  },
  headerLines:[
    { text: empresaSelecionada?.IdRelatorio, align: 'left' },
    { text: `Relação de Alunos por Turma - ${periodoSelecionado?.Descricao}`, align: 'left' },
    { text: formData.ClassificadoPor == 'T+O' ? 'Organizado por Nº Ordem' : 'Organizado por Nome', align: 'left' },
  ],
  operatorName: usuario?.Nome,

  // Adiciona os conteúdos ao relatório
  // O conteúdo é um array de objetos que representam os elementos do relatório
  content: [    
    ...data.reduce((acc: any[], item: any, idx: number, arr: any[]) => {
      const isFirst = idx === 0 || item.TurmaCodigo !== arr[idx - 1].TurmaCodigo;
      if (isFirst) {
        const turmaDescricao = item.TurmaDescricao || '-';
        const grupo = arr.filter((i: any) => i.TurmaCodigo === item.TurmaCodigo);              
          acc.push({
          type: "tabela",
          id: `tabela-${item.TurmaCodigo}`,
          title: turmaDescricao,
          columns: [
            ...(formData.ImprimirNumeroOrdem
            ? [{
                name: "Nº",
                titleAlignment: 'centro',
                dataAlignment: "centro",
                width: "3%",
                allowBreak: false,
              }]
            : []),
            {
              name: "MATRÍCULA",
              headerAlignment: 'centro',
              dataAlignment: "centro",
              width: "11%",
            },  
            {
              name: "NOME",
              headerAlignment: 'esquerda',
              dataAlignment: "esquerda",
              allowBreak: true,
            },            
            {
              name: "ASSINATURA",
              headerAlignment: "centro",
              dataAlignment: 'centro',
            },           
          ],
          dados: grupo.map((aluno: any) => {
            const row = [];
            if (formData.ImprimirNumeroOrdem) 
              row.push(aluno.NumeroOrdem);
            
            row.push(aluno.Matricula);
            row.push(
              getColumnNome(aluno, formData),              
              '', // Espaço para a assinatura              
            );
                        
            return row;
          }),
          });
          
          // Adiciona o total de alunos
          if (formData.ImprimirTotalAlunos)
            acc.push({
                type: "texto",
                id: `total-${item.TurmaCodigo}`,
                title: {
                  text: `QUANTIDADE DE ALUNOS: ${grupo.length}`,
                  alignment: 'esquerda', // "esquerda", "direita", "centralizado", "justificado"
                },
            });
          
          // Adiciona a quebra de página
          acc.push({
            type: "quebra-pagina"
          });
            
        }
        return acc;
      }, []),          
    ]
  };

  return report;
}

export default buildAlunosAssinatura;